import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet";

import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import CookieConsent from "../components/cookieConsent/CookieConsent";
import AlternatesContext from "../components/header/AlternatesContext";

const Layout = (props) => {
  const [alternates, setAlternates] = useState(null);

  return (
    <AlternatesContext.Provider value={setAlternates}>
      <Helmet htmlAttributes={{ lang: props.lang }} />
      <Header lang={props.lang} alternates={alternates}/>
      <Outlet />
      <Footer lang={props.lang}/>
      <CookieConsent lang={props.lang}/>
    </AlternatesContext.Provider>
  )
};

export default Layout;
